import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../../../../utils/rel';

class Tab extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        tabs: PropTypes.array,
        handleMouseOver: PropTypes.func,
    };

    render() {
        const { content, tabs, handleMouseOver } = this.props;

        return (
            <div className={styles.tabTitle}>
                <div className={styles.tabHead}>
                    {tabs.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                                {index === 1 && item.prov && item.city ? <span>|</span> : ''}
                                <a
                                    index={index}
                                    href={item.url}
                                    target="_blank"
                                    rel={rel}
                                    onMouseOver={handleMouseOver}>
                                    {item.title}
                                </a>
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default errorBoundary(Tab);
